const getStageImportance = (stage: string) => {
  if (stage === 'production') return 3;
  if (stage === 'staging') return 2;
  if (stage === 'development') return 1;
  return 0;
};

export const deploymentSortComparator = (a: { id: number; stage: string }, b: { id: number; stage: string }, pins: number[] = []) => {
  const ap = pins.indexOf(a.id);
  const bp = pins.indexOf(b.id);
  if (ap >= 0 || (bp >= 0 && ap !== bp)) return bp - ap;
  return getStageImportance(b.stage) - getStageImportance(a.stage) || a.id - b.id;
};

const longCurrencyFormatter = new Intl.NumberFormat('fi-FI', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 3,
});

const shortCurrencyFormatter = new Intl.NumberFormat('fi-FI', {
  style: 'currency',
  currency: 'EUR',
});

export const formatPrice = (value: number, long = true) =>
  value === 0 ? 'Free' : (long ? longCurrencyFormatter : shortCurrencyFormatter).format(value);
